<template>
  <v-sheet class="d-inline-block">
    <span style="position: absolute; right: 0; z-index: 2">
      <v-btn @click="toggleCode" icon>
        <v-icon>code</v-icon>
      </v-btn>
      <v-btn @click="copy" icon>
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
      <v-btn icon @click="print">
        <v-icon>print</v-icon>
      </v-btn>
    </span>
    <div
      id="receipt"
      class="opacity-1"
      style="position: relative; display: inline-block;"
    >
      <pre
        style="text-align: left; display: inline-block;"
        :class="$vuetify.breakpoint.smAndDown ? 'mobile' : ''"
        v-html="content"
      />
      <img
        v-if="qrcode"
        :src="qrcode"
        style="position: absolute; bottom: 0; right: 0;"
      />
    </div>
  </v-sheet>
</template>
<script>
import QRCode from "qrcode";
export default {
  name: "ReceiptSheet",
  props: {
    order: { type: Object }
  },
  data() {
    return {
      receipt: "",
      content: "",
      qrcode: null
    };
  },
  computed: {
    nonfiscal() {
      return !this.order.registrationInfo.fiscalSign;
    }
  },
  async mounted() {
    this.receipt = await this.order.print();
    this.content = this.receipt;
    if (!this.order.receipt.correction && !this.nonfiscal) {
      this.qrcode = await QRCode.toDataURL(this.order.qr, {
        scale: 2,
        errorCorrectionLevel: "L"
      });
    }
  },
  methods: {
    toggleCode() {
      if (this.content === this.receipt) {
        this.content = JSON.stringify(this.order, null, 2);
      } else {
        this.content = this.receipt;
      }
    },
    print() {
      var prtContent = document.getElementById("receipt");
      var WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(
        '<div style="transform: scale(0.8)">' + prtContent.outerHTML + "</div>"
      );
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    async copy() {
      var prtContent = document.getElementById("receipt");
      await this.$copyText(prtContent.innerText);
      this.$store.commit(
        "notifications/success",
        "Чек скопирован в буфер обмена"
      );
    }
  }
};
</script>
<style scoped>
.mobile {
  font-size: 12px;
}
</style>
